import React, { useEffect } from 'react';

import { Clinic } from '@/utils/schema';
import { Helmet } from 'react-helmet-async';

interface PageMetaProps {
  title?: string;
  description?: string;
  clinic?: Clinic | null;
}

const PageMeta: React.FC<PageMetaProps> = ({
  title = 'Odonto - #1 Booking App for Dentists',
  description = 'Schedule your dental appointments easily with Odonto.',
  clinic
}) => {
  const processTemplate = (template: string, clinicName?: string | null) => {
    if (!template.includes('{clinic}')) {
      return template;
    }

    if (!clinicName) {
      return template
        .replace(/\s+at\s+\{clinic\}/g, '')
        .replace(/\{clinic\}/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    return template.replace(/\{clinic\}/g, clinicName);
  };

  const processedTitle = processTemplate(title, clinic?.name);
  const processedDescription = processTemplate(description, clinic?.name);

  // Fallback: manually update meta tags in case Helmet does not update them as expected
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const metaTags = document.querySelectorAll('meta');
      metaTags.forEach((meta) => {
        if (meta.getAttribute('property') === 'og:title') {
          meta.setAttribute('content', processedTitle);
        }
        if (meta.getAttribute('property') === 'og:description') {
          meta.setAttribute('content', processedDescription);
        }
        if (meta.getAttribute('name') === 'description') {
          meta.setAttribute('content', processedDescription);
        }
        if (meta.getAttribute('name') === 'twitter:title') {
          meta.setAttribute('content', processedTitle);
        }
        if (meta.getAttribute('name') === 'twitter:description') {
          meta.setAttribute('content', processedDescription);
        }
      });
    }
  }, [processedTitle, processedDescription]);

  return (
    <Helmet>
      <title>{processedTitle}</title>
      <meta name="description" content={processedDescription} />
      <meta property="og:title" content={processedTitle} />
      <meta property="og:description" content={processedDescription} />
      <meta name="twitter:title" content={processedTitle} />
      <meta name="twitter:description" content={processedDescription} />
    </Helmet>
  );
};

export default PageMeta;
